(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ridi-hero-slides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ridi-hero-slides')) {
    class RidiHeroSlides extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ref="track"]');
        this.slides = Array.from(this.querySelectorAll('[data-ref="slide"]'));
        this.dots = Array.from(this.querySelectorAll('[data-ref="dot"]'));
        this.prevButton = this.querySelector('[data-ref="prev"]');
        this.nextButton = this.querySelector('[data-ref="next"]');
        if (!this.track || this.slides.length < 2) return;

        this.index = 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.ticking = false;

        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + 1, true); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index - 1, true); }
        });
        if (this.prevButton) this.prevButton.addEventListener('click', () => this.go(this.index - 1, true));
        if (this.nextButton) this.nextButton.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));

        const seconds = Number(this.dataset.autoplay || 0);
        if (seconds > 0 && !this.reducedMotion) this.startAutoplay(seconds * 1000);
        this.sync(0);
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          const width = this.track.clientWidth || 1;
          const next = Math.round(this.track.scrollLeft / width);
          if (next !== this.index) this.sync(next);
          this.ticking = false;
        });
      }

      go(target, userInitiated) {
        const count = this.slides.length;
        const next = ((target % count) + count) % count;
        const behavior = this.reducedMotion ? 'auto' : 'smooth';
        this.track.scrollTo({ left: next * this.track.clientWidth, behavior });
        this.sync(next);
        if (userInitiated) this.stopAutoplay();
      }

      sync(next) {
        this.index = next;
        this.dots.forEach((dot, i) => dot.setAttribute('aria-selected', i === next ? 'true' : 'false'));
        const mode = this.slides[next] && this.slides[next].dataset.textMode;
        this.classList.toggle('ridi-slides--active-dark', mode === 'dark');
      }

      startAutoplay(interval) {
        this.stopAutoplay();
        this.timer = window.setInterval(() => {
          if (document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
          this.go(this.index + 1, false);
        }, interval);
      }

      stopAutoplay() {
        if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
      }
    }
    customElements.define('ridi-hero-slides', RidiHeroSlides);
  }

  } catch(e) { console.error(e); }
})();
})();
